import React, { Component } from "react";

import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import WidgetPopup from "../../widget/WidgetPopup";
import { ExclamationShieldOutline } from 'antd-mobile-icons'
import { Dialog } from 'antd-mobile'
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userInfo: {},
            optionsData: [],
            defaultValue: [],
            pageInfo: {},
            tipsInfo: {},
            popupRef: null,
            isWeixin: true
        }
        this.onClickCity = this.onClickCity.bind(this)
    }
    componentDidMount() {
        // 处理URL参数
        const paramsData = new URLSearchParams(window.location.search);
        const urlParams = JSON.parse(decodeURIComponent(paramsData.get('urlData') || '{}'))
        if (urlParams.urlArr) {
            localStorage.setItem('defaultValue', urlParams.urlArr)
        }
        if (urlParams.urlName) {
            localStorage.setItem('ProvincialUrbanAreas', urlParams.urlName)
        }


        this.getLoginToken();
        this.determineWx()
        if (!localStorage.getItem('_user_info_')) {
            // localStorage.removeItem('ProvincialUrbanAreas')
            // localStorage.removeItem('defaultValue')
            localStorage.removeItem('_template_info_')
        }
    }
    determineWx() {
        var ua = navigator.userAgent.toLowerCase();
        this.setState({
            isWeixin: ua.indexOf('micromessenger') !== -1
        })
    }
    onChange(value) {
        console.log(value);
    };
    conditionBtn(num) {

        const { userInfo, defaultValue } = this.state;
        if (!userInfo.qrid) {
            this.props.history.push({ pathname: "/home/login", state: {} });
            return
        }
        if (num === 1 || num === 3) {
            this.props.history.push({ pathname: "/home/filling", state: { SSQXID: defaultValue[defaultValue.length - 1] } });
        }
        if (num === 2) {
            this.props.history.push({ pathname: "/home/historyList", state: {} });
        }
    }
    getLoginToken() {
        this.getUserInfo()
        // WidgetAjax.ajax({
        //     url : Config.getBasePath()+'/login', 
        //     params : {
        //         username: "admin",
        //         secret: "83F721314D0DCA74195F7AA79623F5FB"
        //     }, 
        //     callback : (data)=>{
        //         if(data&&data.access){
        //             //localStorage.setItem("_user_access_",data.access)
        //             this.getUserInfo()
        //         }
        //     }
        // },this);
    }
    getUserInfo() {
        let userInfo = localStorage.getItem("_user_info_")
        let defaultValue = localStorage.getItem("defaultValue")
        let ProvincialUrbanAreas = localStorage.getItem("ProvincialUrbanAreas")
        if (userInfo) {
            let info = JSON.parse(userInfo)
            this.setState({
                userInfo: info
            })
            //this.querySbpzlist(info.qrtype)
            this.queryAuditMaxnewinfo()
        }
        if (defaultValue && ProvincialUrbanAreas) {
            this.onClickCity(ProvincialUrbanAreas, defaultValue)
        }
    }
    querySbpzlist(CODE) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/sbpzlist',
            params: { CODE: 530304 },
            callback: (data) => {
                if (data && data.status === 0) {
                    data.results.forEach(da => {
                        da.value = da.SSQXID
                        da.label = da.SSQXMC
                    })
                    this.setState({
                        optionsData: data.results,
                        defaultValue: [data.results[0].SSQXID]
                    })
                    this.queryInfo(data.results[0].SSQXID)
                }
            }
        }, this);
    }
    queryInfo(SSQXID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/template/info',
            params: {
                SSQXID: SSQXID
            },
            callback: (data) => {
                if (data && data.status === 0) {
                    localStorage.setItem("_template_info_", JSON.stringify(data.result))
                    this.setState({
                        pageInfo: data.result
                    })
                }
            }
        }, this);
    }
    queryAuditMaxnewinfo() {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/entsq/audit_maxnewinfo',
            params: {

            },
            callback: (data) => {
                if (data && data.status === 0) {
                    this.setState({
                        tipsInfo: data.result
                    })
                }
            }
        }, this);
    }
    goHistory() {
        this.props.history.push({ pathname: "/home/history", state: { showLabel: true } });
    }
    goNotice() {
        this.props.history.push({ pathname: "/home/notice", state: {} });
    }
    onPopupRef = (ref) => {
        this.popupRef = ref;
    };
    fillingBtn() {
        const { userInfo } = this.state;

        if (localStorage.getItem('ProvincialUrbanAreas') && localStorage.getItem('defaultValue')) {
            if (!localStorage.getItem('_user_info_')) {
                this.props.history.push({ pathname: "/home/history", state: { userInfo: userInfo } });
            } else {
                let defaultValue = localStorage.getItem('defaultValue').split(',')
                this.querySetting(defaultValue[defaultValue.length - 1])
                // this.props.history.push({ pathname: "/home/filling", state: { showLabel: true } });
            }
        } else {
            this.popupRef.LayerBtn()
        }
        //     if(!userInfo.qrid){
        //         this.props.history.push({ pathname: "/home/login", state: {} });
        //     }else{
        //         let defaultValue =localStorage.getItem('defaultValue').split(',')
        //         this.querySetting(defaultValue[defaultValue.length-1])
        //         // this.props.history.push({ pathname: "/home/history", state: {showLabel: true} });
        //     }
    }
    goLoginBtn() {
        const { userInfo } = this.state;
        if (!userInfo.qrid) {
            this.props.history.push({ pathname: "/home/login", state: {} });
        } else {
            this.props.history.push({ pathname: "/home/historyList", state: {} });
        }
    }
    querySetting(SSQXID) {
        WidgetAjax.ajax({
            url: Config.getBasePath() + '/businessSystem/setting',
            params: {
                SSQXID: SSQXID,
                TASKID: this.state?.pageInfo?.TASKID
            },
            callback: (data) => {

                if (data && data.status === 0) {
                    this.setState({
                        settingInfo: data.result
                    })
                    if (data.result.STATE === '0') {
                        Dialog.alert({
                            content: '您好，当前不在申报期，无申报任务，请在申报期内申报！',
                            onConfirm: () => {
                                console.log('Confirmed')
                            },
                        })
                    }
                    if (data.result.STATE === '10') {
                        Dialog.alert({
                            content: '您申报的个体工商户已被撤销认定，['+ data.result.CXSJ+ ']后可再次申报。',
                            onConfirm: () => {
                                console.log('Confirmed')
                            },
                        })
                    }
                    if (data.result.SFSB === '9') {
                        Dialog.alert({
                            content: '您已参与其他年度的申报并被评定成功，感谢您的参与！',
                            onConfirm: () => {

                                this.props.history.push({ pathname: "/home/historyList", state: { settingInfo: data.result } });
                            },
                        })
                    }
                    if (data.result.SFSB === '1') {
                        this.props.history.push({ pathname: "/home/historyList", state: {} });
                    }
                    if (data.result.STATE === '1' && data.result.SFSB === '0') {
                        this.props.history.push({ pathname: "/home/history", state: { showLabel: true } });
                    }
                } else {
                    Dialog.alert({
                        content: data.message,
                        onConfirm: () => {
                            console.log('Confirmed')
                        },
                    })

                }
            }
        }, this);
    }
    choiceCityBtn() {
        this.popupRef.LayerBtn()
    }
    onClickCity(cityStr, cityValue) {
        let cityList = cityStr.split(',')
        let cityValueList = cityValue.split(',')
        this.queryInfo(cityValueList[cityValueList.length - 1])
        this.setState({
            cityName: cityList[cityList.length - 1]
        })
    }
    goPage() {
        this.setState({
            isWeixin: true
        })
    }
    render() {
        const { popupInfo, cityName, userInfo, isWeixin } = this.state
        return (
            <div data-component="index" >
                <div className="sg-index-layer sd-middle" style={{ display: !isWeixin ? 'flex' : 'none' }}>
                    <div className="sg-layer-center">
                        <div className="sg-center-top sd-start"><ExclamationShieldOutline color={'#ff0000'} fontSize={'16px'} style={{ marginRight: '8px' }} />  提示</div>
                        <div className="sg-center-center">请在微信浏览器中打开页面</div>
                        <div className="sg-center-bottom" onClick={() => { this.goPage() }}>关闭</div>
                    </div>
                </div>
                <div className="sg-app-index">
                    <div className="sg-index-top">
                        <img className='sg-top-img' alt='#' src={require('../../img/business/indexBg2.png')} />
                        <div className="sg-top-label">
                            <div className="sg-top-logo">
                                <img className='sg-logo-img' alt='#' src={require('../../img/business/logo.png')} />
                            </div>
                            <div className="sg-top-options sd-spaceBetween">
                                <div className="sg-options-left sd-middle" onClick={() => { this.choiceCityBtn() }}>
                                    <img className='sg-left-img' alt='#' src={require('../../img/business/local.png')} />
                                    <div className="sg-left-font sd-fontHidden">{cityName || '全国'}</div>
                                    <img className='sg-left-img' alt='#' src={require('../../img/business/downLine.png')} />
                                </div>
                                <div className="sg-options-right sd-end" onClick={() => { this.goLoginBtn() }}>
                                    <img className='sg-right-icon' alt='#' src={require('../../img/business/peopel.png')} />
                                    <div className="sg-right-name sd-fontHidden">{userInfo.qrid ? userInfo.entname : '您还没有登录'}</div>
                                </div>
                            </div>
                            <div className="sg-label-center">
                                <img className='sg-right-bg' alt='#' src={require('../../img/business/tipsLayer.png')} />
                                <div className="sg-center-title">“名特优新”个体工商户申报工作正式启动</div>
                                <div className="sg-center-font">
                                    <div style={{ textIndent: '28px' }}>为贯彻落实国务院《促进个体工商户发展条例》及《市场监管总局办公厅关于在部分地区先行先试推进个体工商户分型分类精准帮扶的通知》（市监注发〔2023〕28号），进一步推进全国个体工商户分型分类精准帮扶工作，提升个体工商户长期整体发展质量，现开展个体工商户“名特优新”申报评定工作，广大符合条件要求的个体工商户可以选择所在地区积极报名。</div>
                                </div>
                                {/* <div className="sg-center-defined" style={{display:!pageInfo.MBMS?'block':'none'}}>
                                    <img className='sg-defined-img' alt='#' src={require('../../img/business/defined.png')} />
                                    <div className="sg-defined-tips"></div>
                                </div> */}
                                <img className='sg-right-city' alt='#' src={require('../../img/business/city.png')} />
                            </div>

                            <div className="sg-bottom-view">
                                <img className='sg-bottom-bg' alt='#' src={require('../../img/business/indexBg3.jpg')} />
                            </div>
                        </div>
                    </div>
                    <div className="sg-app-bottom sd-middle">
                        <div className="sg-bottom-btn sd-middle" onClick={() => { this.fillingBtn() }}>我要申报</div>
                    </div>
                </div>
                <WidgetPopup popupInfo={popupInfo} onRef={this.onPopupRef} onClickCity={this.onClickCity}></WidgetPopup>
            </div>
        )
    }
}

export default Index
